import { render, staticRenderFns } from "./profitChart.vue?vue&type=template&id=0efc0c93&scoped=true&"
import script from "./profitChart.vue?vue&type=script&lang=js&"
export * from "./profitChart.vue?vue&type=script&lang=js&"
import style0 from "./profitChart.vue?vue&type=style&index=0&id=0efc0c93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efc0c93",
  null
  
)

export default component.exports